import { Link, createFileRoute } from '@tanstack/react-router'

import { useMyLounges } from '@/features/lounges/api'

export const Route = createFileRoute('/_app/')({
  component: LoungeList,
})

function LoungeList() {
  // The `_app` loader already warmed this, so there is no spinner to render.
  const { data } = useMyLounges()
  const lounges = data?.myLounges ?? []

  return (
    <div className="pane-column">
      <header>
        <h1 className="pane-title">Your lounges</h1>
      </header>

      {lounges.length === 0 ? (
        <div className="lounge-empty">
          <p className="muted">
            You are not in any lounges yet. Make one, or follow an invite link someone sent you.
          </p>
          <Link to="/lounges/new" className="btn btn-primary">
            Create a lounge
          </Link>
        </div>
      ) : (
        <ul className="lounge-list">
          {lounges.map((lounge) => (
            <li key={lounge.id}>
              <Link
                to="/l/$loungeSlug"
                params={{ loungeSlug: lounge.slug }}
                className="lounge-card"
              >
                <div>
                  <p className="lounge-card-name">{lounge.name}</p>
                  <p className="lounge-card-meta">
                    {lounge.memberCount === 1 ? 'One member' : `${lounge.memberCount} members`}
                    {/* Null only for an instance admin looking at a lounge they
                     * are not actually in — rare, and "no role" is the honest
                     * thing to show rather than inventing one. */}
                    {lounge.myRole && ` · ${lounge.myRole.toLowerCase()}`}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
